<template>
  <div>
    <Identification :value="profile" @input="$emit('input')" v-if="active" />
  </div>
</template>

<script>
import Identification from '@/components/candidate/profile/edit/details/Identification'

export default {
  components: { Identification },
  props: { profile: { type: Object, required: true }, active: { type: Boolean, default: false } },
}
</script>
